namespace GeniuzPOS.Purchase {
    export interface ReportPendingPODtForm {
    }

    export class ReportPendingPODtForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ReportPendingPODt';
    }
}
